import * as CalculatedNutrientList from 'types/Recipe/Detail/ErpNew/CalculatedNutrientList';

export type Type = {
	name: string;
	sortOrder: number;
	nutrients: CalculatedNutrientList.Type;
};

export function getFromNutrientList(obj: CalculatedNutrientList.Type): Type[] {
	return obj
		.groupBy((x) => x.category)
		.map((k: string, nutrients: CalculatedNutrientList.Type) => {
			return {
				name: k,
				sortOrder: nutrients[0].nutrientCategorySortOrder,
				nutrients: nutrients.orderBy((x) => x.nutrient),
			};
		})
		.orderBy((x) => [x.sortOrder, x.name]);
}

export function filterOutEmptyGroups(
	e: Type,
	nutrientsA: { [nutrientId: string]: number | null },
	nutrientsB: { [nutrientId: string]: number | null }
): boolean {
	const nutrientIds = [...Object.keys(nutrientsA ?? {}), ...Object.keys(nutrientsB ?? {})];
	for (const i of e.nutrients) {
		if (nutrientIds.includes(i.id ?? '')) {
			return true;
		}
	}
	return false;
}
